<template>
  <PhonePreviewLayout :settings="settings">
    <template #header>
      <div class="screen-header">
        <img
          v-if="selectedHeaderPreview?.image?.url"
          class="screen-header__img"
          :src="selectedHeaderPreview.image.url"
          alt="Header cover"
        />
        <div v-else class="screen-header__placeholder"></div>
        <ul class="screen-header__btns">
          <li
            v-for="(_, idx) in [...Array(2)]"
            :key="idx"
            class="screen-header__btn"
            :style="{
              background: headerButtonBgColor,
              color: settings?.headerButton?.textColor,
            }"
          >
            Пример {{ idx + 1 }}
          </li>
        </ul>
      </div>
    </template>
    <template #content>
      <PhonePreviewFilters :filterBtns="filterBtns" :settings="settings" />
      <div class="screen-sport">
        <PhonePreviewSportBlock :settings="settings" />
      </div>
    </template>
  </PhonePreviewLayout>
</template>
<script>
import PhonePreviewLayout from '@/views/apps/custom-pages/components/phone/parts/PhonePreviewLayout.vue'
import PhonePreviewSportBlock from '@/views/apps/custom-pages/components/phone/parts/PhonePreviewSportBlock.vue'
import PhonePreviewFilters from '@/views/apps/custom-pages/components/phone/parts/PhonePreviewFilters.vue'

import { mapGetters } from 'vuex'

import { addOpacity } from '@/services/utils/color'

export default {
  components: {
    PhonePreviewLayout,
    PhonePreviewSportBlock,
    PhonePreviewFilters,
  },
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      filterBtns: [
        {
          text: '',
          icon: 'close',
          iconPlacement: 'start',
          active: false,
        },
        {
          text: 'Пример 1',
          icon: 'forward',
          iconPlacement: 'start',
          active: true,
        },
        {
          text: 'Пример 2',
          icon: 'caret-down',
          iconPlacement: 'end',
          active: false,
        },
        {
          text: 'Пример 3',
          icon: 'mail',
          iconPlacement: 'start',
          active: false,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('content', ['header']),
    ...mapGetters('settings', ['selectedLanguage']),
    selectedHeaderPreview() {
      return this.header[this.selectedLanguage] ?? this.header.ru
    },
    headerButtonBgColor() {
      const color = this.settings?.headerButton?.bgColor
      return this.settings?.headerButton?.overlaySchema === 'light' ? addOpacity(color, 0.2) : addOpacity(color, 0.08)
    },
  },
}
</script>
<style scoped lang="scss">
.screen-header {
  position: relative;

  &__img {
    max-width: 100%;
  }

  &__placeholder {
    width: 240px;
    height: 160px;
  }

  &__btns {
    overflow-x: auto;
    position: absolute;
    left: 10px;
    bottom: 7px;
    list-style: none;
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding: 0;
  }

  &__btn {
    flex: 0 0 auto;
    border-radius: 5px;
    padding: 4px 6px;
    font-weight: 500;
    font-size: 8px;
    line-height: 10px;
    text-align: center;
  }
}
</style>
